/* Optional enhancements only; shopping, navigation, forms and FAQ work without JS. */
(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('.cc-faq-list').forEach(function (list) {
      if (list.dataset.ccBound) return;
      list.dataset.ccBound = 'true';
      list.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          list.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
